export default __webpack_public_path__ + "static/media/logoBflash.0285d951.svg";